export enum TimeType {
    SLA = 'sla',
    OLA = 'ola',
    MAX_TIME = 'maxtime',
    MAX_TIME_HOUR = 'maxtimehour',
}